import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Avatar from '../../../../../react/features/base/avatar/components/Avatar';
import Dialog from '../../../../../react/features/base/ui/components/web/Dialog';
import Input from '../../../../../react/features/base/ui/components/web/Input';
import Spinner from '../../../../../react/features/base/ui/components/web/Spinner';
import { participantMatchesSearch } from '../../../../../react/features/participants-pane/functions';
import { getVisitorList } from '../../functions';
const useStyles = makeStyles()(() => {
    return {
        noParticipantsTitle: {},
        inputSearch: {
            marginBottom: 20,
            'input:focus': {
                boxShadow: 'none'
            },
            'input[disabled]': {
                opacity: '0.3'
            }
        },
        listItem: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: 'rgba(255, 255, 255, 0.15) 0px -1px 0px inset',
            padding: '10px 0'
        },
        leftColumn: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        userName: {
            marginLeft: 15
        }
    };
});
const VisitorsList = () => {
    const { classes: styles } = useStyles();
    const { t } = useTranslation();
    const [searchString, setSearchString] = useState('');
    const [visitorList, setVisitorList] = useState([]);
    const [isVisitorListNotEmpty, setIsVisitorsListNotEmpty] = useState(false);
    const [showLoader, setShowLoader] = useState(true);
    // @ts-ignore
    const { roomToken, baseUrl } = useSelector((state) => state['features/base/config']);
    useEffect(() => {
        getVisitorList(baseUrl, roomToken).then(({ result }) => {
            if (Array.isArray(result)) {
                setVisitorList(result);
                setShowLoader(false);
            }
        });
    }, []);
    useEffect(() => {
        setIsVisitorsListNotEmpty(visitorList.length > 0);
    }, [visitorList]);
    return (React.createElement(Dialog, { disableAutoHideOnSubmit: true, cancel: { hidden: true }, ok: { hidden: true }, size: 'medium', titleKey: t('dialog.visitorListTitle') },
        React.createElement(React.Fragment, null, showLoader ? (React.createElement("div", { className: 'flex_center' },
            React.createElement(Spinner, { size: 'medium' }))) : (React.createElement(React.Fragment, null, isVisitorListNotEmpty ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.inputSearch },
                React.createElement(Input, { id: 'visitor-search', clearable: true, onChange: setSearchString, placeholder: t('participantsPane.search'), value: searchString })),
            visitorList.map(currentObject => {
                const { name } = currentObject;
                return (participantMatchesSearch(currentObject, searchString) && (React.createElement("div", { className: styles.listItem },
                    React.createElement(React.Fragment, null,
                        React.createElement(Avatar, { className: 'visitor-avatar', displayName: name, size: 35 }),
                        React.createElement("div", { className: styles.leftColumn },
                            React.createElement("div", { className: styles.userName }, name))))));
            })))
            : React.createElement("span", { className: styles.noParticipantsTitle }, t('dialog.visitorListEmpty')))))));
};
export default VisitorsList;
